import React from 'react'
import { Container, Tabs, Tab, Button } from 'react-bootstrap'
import { GAMES_COLLECTION } from '../../firebase'
import { useHistory, useParams } from 'react-router';

const DeleteGame = () => {

    const { id } = useParams()

    const history = useHistory()

    const handleDelete = () => {
        GAMES_COLLECTION.doc(id).delete()
            .then(() => {
                alert("Uspješno obrisano 👍")
                history.push('/')
            })
            .catch((error) => {
                alert(error.message)
            })
    }

    return (
        <>
            <Container>
                <Tabs defaultActiveKey="delete-game" className="mb-3" transition={false}>
                    <Tab eventKey="preview-game" title={<div onClick={() => history.push('/')}>Pregled igara</div>} />
                    <Tab eventKey="add-game" title={<div onClick={() => history.push('/add-game')}>Dodaj</div>} />
                    <Tab eventKey="edit-game" title='Uredi' disabled />
                    <Tab eventKey="delete-game" title='Obriši'>
                        <Button variant="danger" onClick={handleDelete}>Obriši</Button>
                    </Tab>
                </Tabs>
            </Container>
        </>
    )
}

export default DeleteGame
